<template>
  <label
    :for="id"
    :class="fieldClasses"
    :style="fieldStyle">

    <span
      v-if="label"
      ref="label"
      :class="labelClasses"
      :style="labelStyle">
      {{ label }}
      <span
        v-if="optional && !disabled"
        :class="optionalClass"
        :style="optionalStyle">
        <slot name="optional">{{ optionalMessage }}</slot>
      </span>

      <slot name="hint" />
    </span>

    <div class="relative">
      <select
        :id="id"
        ref="input"
        :class="selectClasses"
        :style="inputStyle"
        :value="value"
        @change="onInput"
        v-bind="$attrs"
        v-on="listeners"
        :disabled="disabled">
        <slot>
          <option
            v-if="placeholder"
            value=""
            disabled>{{ placeholder }}</option>
          <option
            v-if="optional"
            value=""/>

          <template v-if="Array.isArray(options)">
            <option
              v-for="(name, index) in options"
              :key="index"
              :value="name">
              {{ name }}
            </option>
          </template>

          <template v-else>
            <option
              v-for="(option, name) in options"
              :key="name"
              :value="name">
              {{ option }}
            </option>
          </template>
        </slot>
      </select>
    </div>

    <slot name="extra" />
  </label>
</template>

<script>
import FormControl from './mixins/FormControl'
import InputControl from './mixins/InputControl'

export default {
  mixins: [FormControl, InputControl],

  inheritAttrs: false,

  props: {
    options: {
      type: [Array, Object],
      default: () => ({})
    },
    withoutCaret: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    listeners () {
      const listeners = { ...this.$listeners }

      delete listeners.input
      delete listeners.blur
      delete listeners.focus

      return listeners
    },
    selectClasses () {
      return [...this.inputClass, 'appearance-none', {
        [this.activeClass.input]: this.active,
        [this.disabledClass.input]: this.disabled,
        [this.$style['caret']]: !this.withoutCaret
      }]
    }
  }
}
</script>

<style lang="scss" module>
.caret {
  background-image: linear-gradient(45deg, transparent 50%, currentColor 50%), linear-gradient(135deg, currentColor 50%, transparent 50%);
  background-position: calc(100% - 20px) 1em, calc(100% - 15px) 1em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
}
</style>
